/* -- set app title --*/
const AppTitle = 'Sales AI';

/* -- set app mode -- */
const AppMode = ['', 'development', 'production', 'testing'];

/* -- set API URLs --*/
let testing = 'https://server.salesai.digital';
let development = 'https://server.salesai.digital';
let production = 'https://server.salesai.digital';

let ApiUrl;
switch (AppMode[2]) {
  case 'development':
    ApiUrl = development;
    break;
  case 'production':
    ApiUrl = production;
    break;
  case 'testing':
    ApiUrl = testing;
    break;
  default:
    ApiUrl = 'http://localhost:4005';
}

// // Local branding test: route API through the CRA dev proxy (src/setupProxy.js),
// // which injects the agency Origin so the backend returns that agency's branding.
// if (process['env']['REACT_APP_LOCAL_BRANDING_TEST'] === 'true') {
//   ApiUrl = ''; // baseURL becomes '/api' (same-origin → proxied)
// }

console.log('************* ApiUrl = ', ApiUrl);

// OAuth Configuration
const oauthConfig = {
  google: {
    clientId: process['env']['REACT_APP_GOOGLE_CLIENT_ID'] || 'YOUR_GOOGLE_CLIENT_ID',
    redirectUri: process['env']['REACT_APP_REDIRECT_URI'] || window['location']['origin'],
  },
  microsoft: {
    clientId: process['env']['REACT_APP_MICROSOFT_CLIENT_ID'] || 'YOUR_MICROSOFT_CLIENT_ID',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: process['env']['REACT_APP_REDIRECT_URI'] || window['location']['origin'],
    scopes: ['user.read', 'profile', 'email', 'openid'],
  },
  apple: {
    clientId: process['env']['REACT_APP_APPLE_CLIENT_ID'] || 'YOUR_APPLE_CLIENT_ID',
    redirectUri: process['env']['REACT_APP_REDIRECT_URI'] || window['location']['origin'],
    scope: 'email name',
  }
}

ApiUrl = `${ApiUrl}/api`;

// LangGraph API Configuration
const LangGraphApiUrl = `${ApiUrl}/automation/workflows`;

// GTM Tracking Mode Configuration
// 0 = Track ALL users (organic + tracking_id users)
// 1 = Track ONLY users with tracking_id (paid campaigns only, exclude organic/direct)
export const GTM_TRACK_MODE = 3; // Set to 1 for production (tracking only), 0 for all users

export { AppTitle, ApiUrl, LangGraphApiUrl, oauthConfig };
